import SelectTemplatePage from './SelectTemplatePage';

export default SelectTemplatePage;
